export default __webpack_public_path__ + "static/media/cortex-logo-horizontal.1cad34a4.png";